<!-- Park transaction -->
<button
  mat-button
  matTooltip="Park this sale for later."
  [disabled]="!valid()"
  [matTooltipShowDelay]="500"
  (click)="parkTransaction()"
>
  <mat-icon>restore</mat-icon>
  <span>Park</span>
</button>

@if (voidable()) {
  <!-- Cancel transaction -->
  <button
    mat-button
    matTooltip="Cancel this sale permanently"
    [disabled]="!valid()"
    [matTooltipShowDelay]="500"
    (click)="voidTransaction()"
  >
    <mat-icon>block</mat-icon>
    <span>Cancel</span>
  </button>
}
